import { ButtonHTMLAttributes } from 'react'
import { DisplayProps, MarginProps, PositionProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import PDSIcon, { IconName } from 'designSystem/components/PDSIcon/PDSIcon'
import INTERNALxButton from 'designSystem/components/internal/elements/INTERNALxButton'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

type IconButtonSize = 'sm' | 'md' | 'lg'

type BaseProps = ButtonHTMLAttributes<HTMLButtonElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  name: IconName
  size?: IconButtonSize
  testId?: string
} & BaseProps

export default function PDSIconButton({
  disabled,
  name,
  size = 'sm',
  testId,
  ...props
}: Props) {
  const buttonSize = ICON_BUTTON_SIZE[size]

  return (
    <INTERNALxButton
      {...props}
      alignItems="center"
      borderRadius={SIZE.s4}
      className="button icon"
      disabled={disabled}
      display="flex"
      height={buttonSize}
      justifyContent="center"
      width={buttonSize}
      testId={testId}
    >
      <PDSIcon
        color={disabled ? COLOR.grey400 : COLOR.grey500}
        name={name}
        size={size}
      />
    </INTERNALxButton>
  )
}

const ICON_BUTTON_SIZE = {
  sm: '1.5rem',
  md: '2rem',
  lg: '2.5rem',
}
